var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page',{attrs:{"slugs":_vm.slugs,"post":_vm.post},scopedSlots:_vm._u([{key:"category",fn:function(){return [(_vm.project === 'rzaska')?[_c('product-tiles',{staticClass:"is-hidden-desktop"})]:_vm._e(),_vm._v(" "),(_vm.project === 'schuette')?[_c('category-tiles',{staticClass:"is-hidden-desktop"})]:_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }